import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { getLegacyCapture, resolveLegacyRedirect } from "@/lib/legacy-redirects";
import { recordLegacyUrlVisit } from "@/lib/legacyUrlRegistry.functions";

/**
 * Catch-all route (lowest priority in TanStack Router).
 *
 * Its only job is migration hygiene: any URL that used to exist on the old
 * WooCommerce site gets a real 301 to its new home, so Google transfers the
 * accumulated ranking instead of dropping it. Everything else falls through
 * to the root `notFoundComponent`.
 */
export const Route = createFileRoute("/$")({
  loader: async ({ params }) => {
    const splat = (params as { _splat?: string })._splat ?? "";
    const sourcePath = `/${splat}`;
    const capture = getLegacyCapture(sourcePath);
    if (capture) {
      const saved = await recordLegacyUrlVisit({ data: capture });
      if (saved.destinationPath) {
        throw redirect({ href: saved.destinationPath, statusCode: 301, reloadDocument: true });
      }
    }
    const target = resolveLegacyRedirect(sourcePath);
    if (target) {
      throw redirect({ href: target, statusCode: 301, reloadDocument: true });
    }
    throw notFound();
  },
});
